import { Button, Card, Form } from '../../../ui';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { Spinner } from '../../../ui';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { verifyLogin } from '../../../../hooks/useAuth';
import { useAuthFlow, useSession } from '../../../../state/app-state';

const VerifyLoginPage: FunctionComponent = () => {
  const session = useSession();
  const authFlow = useAuthFlow();
  const history = useHistory();
  // Legacy relied on isFetching being undefined before the first attempt.
  const startedRef = useRef(false);
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const stateToken = queryParams.get('state');

    if (!stateToken) {
      history.push('/');
      return;
    }

    setToken(stateToken);
  }, [location.search, history, setToken]);

  useEffect(() => {
    if (session && session.account && session.token) {
      history.push('/');
    }

    if (startedRef.current && !authFlow.isFetching) {
      setLoading(false);
    }
  }, [session, authFlow, history]);

  useEffect(() => {
    if (token) {
      startedRef.current = true;
      verifyLogin(token);
    }
  }, [token, verifyLogin]);

  if (!loading) {
    return (
      <div>
        <Card>
          <Card.Body>
            <h1 className="text-2xl font-bold text-gray-900 text-center mb-6">
              Oops, something went wrong
            </h1>
            <Form noValidate>
              <Button className="mt-4 w-full flex" as={Link} to={'/'}>
                Back
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div>
      <Card>
        <Card.Body>
          <h1 className="flex items-center justify-center gap-2 text-2xl font-bold text-gray-900 text-center mb-6">
            <Spinner animation="grow"></Spinner> Verifying login...
          </h1>
        </Card.Body>
      </Card>
    </div>
  );
};

export default VerifyLoginPage;
